import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'angular-2-local-storage';
import { CommonService } from '../../common/common.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, Validators } from '@angular/forms';
import { ReCaptcha2Component } from 'ngx-captcha/lib';
import { UserapiService } from 'src/app/common/userapi.service';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @ViewChild('langInput') langInput: ElementRef;

  public sitekey = "6LfJ1pQpAAAAAMGQpmWkRxXWHGg6x4xb1XML_Hc_";
  public secretkey = "6LfJ1pQpAAAAAGfZmB93lPBkHN4gZY4iI1GwZZl4";
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaisExpired = false;
  public captchaResponse?: string;

  public theme: "light" | "dark" = "light";
  public size: "compact" | "normal" = "normal";
  public lang = "en";
  public type: "image" | "audio" = "image";

  deviceInfo: any;
  capsOn: any;
  username: string = "";
  pwd: string = "";
  recaptcha: "";
  getdata: any;
  isloader: boolean = false;
  showOTP: boolean = false;

  Token: string = "";
  UserEmail: string = "";
  otppanel: boolean = false;
  registmobile: string = "";
  remainingTime: number;
  minutes: number;
  seconds: number;
  CurrentYear: number;
  arr_banner=[];
  arr_onlineservices=[];
  arr_notifications=[];
 FilePath:any;

  LoginBy: number = 0;
  show: boolean = false;


  constructor(private fb: FormBuilder, private http: HttpClient, private route: Router, private deviceService: DeviceDetectorService,
    private Toaster: ToastrService, private common: CommonService, private aroute: ActivatedRoute, private user:UserapiService) {
  }

  ngOnInit() {
    this.bindbanner();
    this.bindnotification();
    this.CurrentYear = new Date().getFullYear();
    this.GetDeviceInfo();
    if (localStorage.getItem("GuestToken") != null || localStorage.getItem("GuestToken") != '') {
      this.route.navigate(['user/dashboard']);
    }
    else {
      localStorage.clear();
      // this.DirectLogin();
    }
  }

  public otpform = this.fb.group({
    guestid: [0, [Validators.required]],
    email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
    mobno: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
    OTP: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
    LoginBy: [0]
  })

  public passwordform = this.fb.group({
    guestid: [0, [Validators.required]],
    email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]],
    mobno: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
    password: ['', [Validators.required]],
    recaptcha: ['', [Validators.required]],
    LoginBy: [1]
  })


  // bindbanner(){
  //   const OnUserLogin=1;
  //   this.arr_banner = [];
  //   this.http.get(environment.apiurlcore +"banner_get_websitehome?OnUserLogin=" + OnUserLogin ).subscribe(data => {
  //     console.log(data)
  //     console.log(this.arr_banner)
      
  //   })
  // }

  bindbanner(){

    const OnUserLogin=1;
    // console.log(uniqueid)
    this.arr_banner = [];
      this.user.GET("banner_get_userlogin?OnUserLogin=" + OnUserLogin).then(data => {
     
          //this.formsearchmaster.patchValue({statusid:1});
        this.arr_banner=data
        //console.log(this.arr_banner)
        
      })
  }

  bindnotification() {
    const IsActive = 1;
    this.user.GET("get_all_notifications?IsActive=" + IsActive).then(data => {
        this.arr_notifications = data.filter(notification => notification.ShowOnOnlineServices == 1);
        
    });
}

  GetDeviceInfo() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
  }

  ClearURL() {
    this.route.navigate([], {
      queryParams: {}
    });
  }
  toggleForm() {
    // this.otpform.get('email').value
    this.passwordform.patchValue({
      email:this.otpform.get('email').value,
      mobno:this.otpform.get('mobno').value,
    })
    if (this.LoginBy == 0) {
      this.LoginBy = 1;
    }
    else {
      this.LoginBy = 0;
    }
  }
  toggleIcon() {
    this.show = !this.show;
  }

  validateform() {
    var flag = true;
    if (this.LoginBy == 0) {
      this.otpform.markAllAsTouched();
      if (this.otpform.invalid) {
        if (this.otpform.get("email").value == "") {
          this.Toaster.warning("Please enter email address.", "", { timeOut: 2000 });
          flag = false;;
        }
        else if (this.otpform.get("mobno").value == "") {
          this.Toaster.warning("Please enter mobile no.", "", { timeOut: 2000 });
          flag = false;
        }
      }
    }
    else if (this.LoginBy == 1) {
      if (this.passwordform.invalid) {
        if (this.passwordform.get("email").value == "") {
          this.Toaster.warning("Please enter email address.", "", { timeOut: 2000 });
          flag = false;;
        }
        else if (this.passwordform.get("mobno").value == "") {
          this.Toaster.warning("Please enter mobile no.", "", { timeOut: 2000 });
          flag = false;
        }
        else if (this.passwordform.get("recaptcha").value == "") {
          this.Toaster.warning("Please validate captcha.", "", { timeOut: 2000 });
          flag = false;
        }
      }
    }

    return flag;
  }

  SignIn() {
    if (this.LoginBy == 0) {
      this.GetOTP();
    }
    else if (this.LoginBy == 1) {
      this.Login();
    }
  }

  GetOTP() {
    this.otpform.patchValue({
      OTP: ''
    })
    var Data = this.otpform.value;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    this.isloader = true;
    let body = JSON.stringify(Data);//Convert frontend Data into Json
    this.http.post(environment.apiurlcore + 'api/user/get_login_otp', body, options).
      subscribe(
        (data: any) => {
          
          if (data.Status) {
            this.otpform.patchValue({ guestid: data.Data.GuestID });
            this.Toaster.success(data.Message, "", { timeOut: 2000 });
            this.showOTP = true;
            this.StartTimer();
          }
          else {
            if (data.Value == 2) {
              this.otpform.patchValue({ guestid: data.Data.GuestID });
              this.Toaster.error(data.Message, "", { timeOut: 2000 });
              this.showOTP = true;
              this.StartTimer();
            }
            else {
              if (data.Value == 2) {
                this.otpform.patchValue({ guestid: data.GuestID });
                this.Toaster.error(data.Message, "", { timeOut: 2000 });
                this.showOTP = true;
                this.StartTimer();
              }
              else {
                this.showOTP = false;
                this.Toaster.error(data.Message, "", { timeOut: 2000 });
              }
            }
            this.isloader = false;
          }
        },
        (err) => {
          this.Toaster.warning("Connection Not Established,Check APis/Db Connection", "", { timeOut: 2000 });
          this.isloader = false;
        }
      );
  }

  Login() {
    if (this.validateform()) {
      var Data = {
        "Email": this.passwordform.get("email").value,
        "MobNo": this.passwordform.get("mobno").value,
        "Password": this.passwordform.get("password").value,
        "BrowserName": this.deviceInfo.browser,
        "OSName": this.deviceInfo.os,
        "OSVersion": this.deviceInfo.os_version,
        "DeviceType": this.deviceInfo.device
      };
      let headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let options = {
        headers: headers
      }
      this.isloader = true;
      let body = JSON.stringify(Data);//Convert frontend Data into Json
      this.http.post(environment.apiurlcore + 'api/user/login', body, options).
        subscribe(
          (data) => {
           
            this.getdata = data;
            if (this.getdata.Status == true) {
              this.Token = this.getdata.Data.Token;
              this.UserEmail = this.getdata.Data.Email;


              localStorage.setItem('GuestToken', this.getdata.Data.Token);
              localStorage.setItem('GuestLogID', this.getdata.Data.LoginLogId);
              localStorage.setItem('GuestID', this.getdata.Data.UserId);
              localStorage.setItem('Email', this.getdata.Data.Email);
              localStorage.setItem('GuestName', this.getdata.Data.LoginUserName);
              localStorage.setItem('UserImageURL', this.getdata.Data.UserImageURL);
              this.Toaster.success("Welcome " + this.getdata.Data.LoginUserName, "", { timeOut: 2000 });

              this.route.navigate(['user/dashboard']);

            }
            else {
              this.Toaster.warning(this.getdata.Message, "", { timeOut: 2000 });
            }
            this.isloader = false;

          },
          (err) => {
            this.Toaster.warning("Connection Not Established,Check APis/Db Connection", "", { timeOut: 2000 });
            this.isloader = false;
          }
        );
    }
  }

  StartTimer() {
    this.remainingTime = (5 * 60 * 1000); // 2 minute from now

    // Update the remaining time every second
    const interval = setInterval(() => {
      const totalSeconds = Math.floor(this.remainingTime / 1000);
      this.remainingTime = this.remainingTime - 1000;
      this.minutes = Math.floor(totalSeconds / 60); // Calculate number of minutes
      this.seconds = totalSeconds % 60;
      // Check if time is up
      if (this.remainingTime < 0) {
        clearInterval(interval);
        this.remainingTime = 0;
      }
    }, 1000);
  }

  ValidateOTP() {
    if (this.otpform.get('OTP').valid) {
      var Data = {
        "guestid": this.otpform.get("guestid").value,
        "email": this.otpform.get("email").value,//insert data from Frontend
        "OTP": this.otpform.get("OTP").value,
        "MobNo":this.otpform.get("mobno").value,
        "BrowserName": this.deviceInfo.browser,
        "OSName": this.deviceInfo.os,
        "OSVersion": this.deviceInfo.os_version,
        "DeviceType": this.deviceInfo.device
      };
      let headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let options = {
        headers: headers
      }
      this.isloader = true;
      let body = JSON.stringify(Data);//Convert frontend Data into Json
      this.http.post(environment.apiurlcore + 'api/user/verify_login_otp', body, options).
        subscribe(
          (data) => {
            //console.log(data);
            this.getdata = data;
            if (this.getdata.Status == true) {
              this.Token = this.getdata.Data.Token;
              this.UserEmail = this.getdata.Data.Email;


              localStorage.setItem('GuestToken', this.getdata.Data.Token);
              localStorage.setItem('GuestLogID', this.getdata.Data.LoginLogId);
              localStorage.setItem('GuestID', this.getdata.Data.UserId);
              localStorage.setItem('Email', this.getdata.Data.Email);
              localStorage.setItem('GuestName', this.getdata.Data.LoginUserName);
              localStorage.setItem('UserImageURL', this.getdata.Data.UserImageURL);
              this.Toaster.success("Welcome " + this.getdata.Data.LoginUserName, "", { timeOut: 2000 });

              this.route.navigate(['user/dashboard']);

            }
            else {
              this.Toaster.warning(this.getdata.Message, "", { timeOut: 2000 });
              if (this.getdata.Message == "OTP expired") {
                this.otpform.get("OTP").patchValue('');
                this.remainingTime = 0;
              }
            }
            this.isloader = false;

          },
          (err) => {
            this.Toaster.warning("Connection Not Established,Check APis/Db Connection", "", { timeOut: 2000 });
            this.isloader = false;
          });
    }
    else {
      this.otpform.get('OTP').markAllAsTouched();
    }
  }

  reset() {
    this.captchaElem.resetCaptcha()
  }
  handleSuccess(data) {
    // console.log(data);
  }
  handleExpire() {
  }
  handleLoad() { }

}